import styled from 'styled-components';

export const SupplierProgressListMainWrap = styled.div(
  props => `
        .suppliersListWrpr{
    background: #F3F0F8;
    border-radius: 8px;
    padding: 16px 10px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.margin10{
    margin-top: 10px;
}

.suppliersListWrpr .suppliersListItem{
    flex-shrink: 0;
    margin-right: 24px;
    display: flex;
    align-items: center;
}
    `,
);
